<template>
	<div class="main">
		<div class="naverwebtoon">
			<img class="close b-close" src="../assets/image/close.png" alt="">
			<a href=""><img src="../assets/image/naverwebtoon_bigbanner.png" alt=""></a>
		</div>
		<div class="box">
			<Header></Header>
			<GameBanner :src="gameData.topBgImage" :variant="gameData.extraFields.bannerType"
				:drawProductId="gameData.extraFields.bannerDrawProductId" />
			<div class="item_welfare">
				<div class="content">
					<UserInfo ref="userInfo"></UserInfo>
					<div class="position">
						<ul>
							<li v-for="(item, index) in welfareList" :key="item.id"
								v-analytics-exposure="{ event: 'activity_exposure', key: item.id, properties: welfareProperties(item) }"
								:class="['welfare-card', 'welfare-card--' + getWelfareActionType(item)]">
								<div class="welfare-limit" v-if="item.threshold">{{ item.threshold }}</div>
								<div class="welfare-icon">
									<img class="first" :src="item.icon" alt="">
								</div>
								<div class="welfare_right">
									<p class="welfare-title">{{ item.title }}</p>
									<p class="prop" v-html="cutout(item.content)"></p>
									<div class="progress-container" v-if="item.amount > 0">
										<div class="percentage">{{ item.progressRate }}%</div>
										<div class="progress-bar" :style="'width:' + item.progressRate + '%'"></div>
									</div>
									<div class="welfare-action">
										<button v-if="getWelfareActionType(item) === 'claim'" :id="'btn_' + item.id"
											v-on:click="receive(item)" class="receive receive--claim">{{
												getWelfareActionText(item)
											}}</button>
										<button v-else class="receive" :class="'receive--' + getWelfareActionType(item)"
											disabled>{{ getWelfareActionText(item) }}</button>
										<div v-if="item.claimed && rewardMode == 0 && item.claimedValue"
											class="package">
											<p>{{ gfitCodeOverlengthOmit(item.claimedValue) }}</p>&nbsp;<i
												class="fa fa-clipboard color" v-clipboard:success="onCopySuccess"
												v-clipboard:copy="item.claimedValue"></i>
										</div>
									</div>
								</div>
							</li>
						</ul>
						<p class="h3"></p>
						<p class="instructions">&nbsp;</p>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>
		<TipsWindow ref="tips"></TipsWindow>
	</div>
</template>

<script>
import $ from 'jquery'
import Header from '../components/header.vue'
import Footer from '../components/footer.vue'
import UserInfo from '../components/userInfo.vue'
import TipsWindow from '../components/tipsWindow.vue'
import GameBanner from '../components/GameBanner.vue'
import axios from 'axios'
import { isEmpty, isNotEmpty } from '../utils/index.js'
import {
	getWelfareJsonUrl
} from '../utils/api'
export default {
	name: 'welfare',
	components: {
		Header,
		Footer,
		UserInfo,
		TipsWindow,
		GameBanner
	},
	data() {
		return {
			rewardMode: 0,
			horseRaceLamp: '',
			startTime: 0,
			endTime: 0,
			welfareList: [],
			gameData: this.$store.state.gameData,
			activityRule: 'official website offers extra top-up rebates. Participate in relevant events on the official\
							website and you will be able to obtain valued gift packages during the event time. When you\
							reach the requirement, you can claim the Gift Code on the official website and redeem it in\
							the game. The Gift Code can only be used once. We do not suggesting giving or exposing the\
							Gift Code to others.'
		}
	},
	mounted() {
		this.initWelfareData();
	},
	methods: {
		welfareProperties(item) {
			return { activity_id: 'welfare:' + item.id, activity_name: item.title, activity_type: 'welfare', eligible: Boolean(item.claimable), already_claimed: Boolean(item.claimed) };
		},
		cutout(cellValue) {
			if (cellValue) {
				return cellValue.replace(/\,/g, '</br>')
			}
		},
		gfitCodeOverlengthOmit: function (giftCode) {
			return giftCode.length > 12 ? (giftCode.substr(0, 12) + "...") : giftCode;
		},
		initWelfareData: function () {
			this.$axios({
				method: 'get',
				url: '/web/api/welfare/initData',
				params: {
					userId: this.$session.getUserId(),
					gameCode: this.$cache.getGameCode(),
				}
			})
				.then(response => {
					if (response.code === 1000) {
						const data = response.data || {};
						this.rewardMode = data.rewardMode;
						this.endTime = data.actEndTime || 0;
						this.welfareList = (data.welfareList || []).map(item => {
							const progressRate = this.calcProgressRate(data.amount, item.amount);
							return Object.assign({}, item, { progressRate });
						});
					}
				})

		},
		calcProgressRate: function (currentAmount, targetAmount) {
			if (!targetAmount || targetAmount <= 0) {
				return 0;
			}
			if (!currentAmount || currentAmount <= 0) {
				return 0;
			}
			return Math.min(100, Math.floor((currentAmount / targetAmount) * 100));
		},
		getWelfareActionType: function (item) {
			if (item.claimed) {
				return 'claimed';
			}
			if (item.enabled && item.claimable) {
				return 'claim';
			}
			return 'unmet';
		},
		getWelfareActionText: function (item) {
			const type = this.getWelfareActionType(item);
			if (type === 'claimed') {
				return this.$t('claimed_text');
			}
			if (type === 'claim') {
				const availableTimes = this.getAvailableTimes(item);
				if (this.toBoolean(item.isPerPaid) && availableTimes > 0) {
					return this.$t('claim_text') + '(' + availableTimes + ')';
				}
				return this.$t('claim_text');
			}
			return this.$t('claim_unmet_text');
		},
		toBoolean: function (value) {
			return value === true || value === 'true' || value === 1 || value === '1';
		},
		getAvailableTimes: function (item) {
			const availableTimes = Number(item && item.availableTimes);
			return Number.isNaN(availableTimes) ? 0 : availableTimes;
		},
		receive: function (item) {
			const properties = this.welfareProperties(item);
			this.$analytics.track('activity_join_requested', properties);
			let _role = this.$cache.getRoleInfo();
			if (isEmpty(_role)) {
				this.$analytics.track('activity_join_failed', { ...properties, reason: 'role_required' });
				this.$refs.userInfo.openRoleChooseWindow();
				return;
			}
			this.$setLoading('btn_' + item.id, true);
			this.$axios({
				method: 'get',
				url: '/web/api/welfare/claim',
				params: {
					userId: this.$session.getUserId(),
					gameCode: this.$cache.getGameCode(),
					serverCode: _role.serverCode,
					roleId: _role.roleId,
					welfareId: item.id
				}
			})
				.then(response => {
					if (response.code === 1000) {
						this.markClaimed(item.id, response.data);
						this.$analytics.track('activity_reward_claimed', properties);
						if (this.rewardMode == 1) {
							this.$refs.tips.show(this.$i18n.tc('receive_reward_tips_text'), {
								type: 'success',
								title: this.$i18n.tc('claim_success_text'),
								duration: 3600
							});
						}
					} else {
						this.$refs.tips.show(response.message, 'error');
						this.$analytics.track('activity_join_failed', { ...properties, reason: 'business_rejected', error_code: response.code });
					}
					this.$setLoading('btn_' + item.id, false);
				}).catch(() => {
					this.$analytics.track('activity_join_failed', { ...properties, reason: 'network_error' });
					this.$setLoading('btn_' + item.id, false);
				})
		},
		markClaimed: function (welfareId, data) {
			const index = this.welfareList.findIndex(item => item.id === welfareId);
			if (index < 0) {
				return;
			}
			const currentItem = this.welfareList[index];
			const result = data && typeof data === 'object' ? data : {};
			const hasOwn = function (field) {
				return Object.prototype.hasOwnProperty.call(result, field);
			};
			const claimedValue = result.giftCode || result.claimedValue ||
				(typeof data === 'string' ? data : currentItem.claimedValue);
			const isPerPaid = hasOwn('isPerPaid') ? this.toBoolean(result.isPerPaid) : this.toBoolean(currentItem.isPerPaid);
			const availableTimes = hasOwn('availableTimes') ? Number(result.availableTimes) :
				Number(currentItem.availableTimes);
			const hasAvailableTimes = !Number.isNaN(availableTimes);
			const canClaimAgain = isPerPaid &&
				this.toBoolean(result.claimable) &&
				!this.toBoolean(result.claimed) &&
				(!hasAvailableTimes || availableTimes > 0);
			const nextItem = Object.assign({}, currentItem, result, {
				isPerPaid: isPerPaid,
				availableTimes: hasAvailableTimes ? availableTimes : currentItem.availableTimes,
				claimed: canClaimAgain ? false : true,
				claimable: canClaimAgain,
				claimStatus: canClaimAgain ? 'claimable' : 'claimed',
				claimedValue: claimedValue
			});
			this.$set(this.welfareList, index, nextItem);
		},
		onCopySuccess(e) {
			this.$refs.tips.show(this.$i18n.tc('copy_successful_text'), 'success');
		}
	}
}
</script>

<style scoped>
.item_welfare {
	background-color: #f3f5f8;
	background-blend-mode: soft-light;
}

.item_welfare .position {
	width: 100%;
	padding: 0.26rem 0.18rem 0.45rem;
	box-sizing: border-box;
}

.item_welfare ul {
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	gap: 0.22rem;
	float: none;
	width: 100%;
	margin: 0 0 0.28rem;
}

.item_welfare ul li.welfare-card {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	float: none;
	width: 100%;
	min-height: 3.3rem;
	height: auto;
	margin: 0;
	padding: 0.34rem 0.22rem 0.22rem;
	box-sizing: border-box;
	overflow: hidden;
	background: linear-gradient(180deg, #ffffff 0%, #fffefe 58%, #fff7ef 100%);
	border: 0.0125rem solid rgba(255, 150, 38, 0.12);
	border-radius: 0.18rem;
	box-shadow: 0 0.14rem 0.36rem rgba(32, 39, 55, 0.12);
}

.item_welfare ul li.welfare-card::before {
	content: '';
	position: absolute;
	top: -0.7rem;
	right: -0.58rem;
	width: 1.72rem;
	height: 1.72rem;
	border-radius: 50%;
	background: rgba(255, 150, 38, 0.1);
}

.item_welfare ul li.welfare-card--claimed {
	background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
	border-color: rgba(0, 0, 0, 0.04);
}

.welfare-limit {
	position: absolute;
	top: 0.12rem;
	right: 0.12rem;
	z-index: 1;
	max-width: 1.25rem;
	padding: 0.035rem 0.1rem;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: #ff8200;
	background: #fff5ec;
	border: 0.0125rem solid #ffe0bf;
	border-radius: 0.18rem;
	font-size: 0.14rem;
	font-weight: 700;
	line-height: 1.3;
}

.welfare-icon {
	position: relative;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 1.18rem;
	height: 1.18rem;
	margin-bottom: 0.16rem;
	border-radius: 0.16rem;
}

.first {
	width: 1.2rem;
	height: 1.2rem;
	margin: 0;
	object-fit: contain;
}

.welfare_right {
	position: static;
	z-index: 1;
	display: flex;
	flex: 1;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: auto;
	margin: 0;
	font-size: 0.17rem;
	text-align: center;
}

.welfare-title {
	display: -webkit-box;
	min-height: 0.45rem;
	margin: 0;
	overflow: hidden;
	color: #232735;
	font-size: 0.17rem;
	font-weight: 600;
	line-height: 1.35;
	text-overflow: ellipsis;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
}

.prop {
	width: 100%;
	height: 0.48rem;
	margin-top: 0.08rem;
	overflow: auto;
	color: #6b7280;
	font-size: 0.145rem;
	line-height: 1.45;
}

.progress-container {
	width: 100%;
	height: 0.12rem;
	margin-top: 0.12rem;
	overflow: hidden;
	background: #edf0f4;
	border-radius: 1rem;
}

.percentage {
	margin-top: -0.01rem;
	color: #ff8200;
	font-size: 0.105rem;
	font-weight: 700;
	line-height: 0.12rem;
}

.progress-bar {
	height: 0.12rem;
	background: linear-gradient(90deg, #ffb13b 0%, #ff7a00 100%);
}

.welfare-action {
	position: relative;
	width: 100%;
	margin-top: auto;
	padding-top: 0.18rem;
}

.receive {
	position: static;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 0.48rem;
	border-radius: 0.12rem;
	border: 0.0125rem solid transparent;
	outline: none;
	font-size: 0.17rem;
	font-weight: 700;
	line-height: 1;
	letter-spacing: 0;
	box-sizing: border-box;
}

.receive--claim {
	color: #fff;
	cursor: pointer;
	background: linear-gradient(180deg, #ffad38 0%, #ff8d1a 100%);
	box-shadow: 0 0.1rem 0.2rem rgba(255, 141, 26, 0.25);
}

.receive--claim:active {
	transform: translateY(0.01rem);
	box-shadow: 0 0.05rem 0.12rem rgba(255, 141, 26, 0.22);
}

.receive--claimed {
	color: #a2a2a2;
	background: #ececec;
	border-color: #ececec;
	cursor: not-allowed;
}

.receive--unmet {
	color: #ff8200;
	background: #fff6ea;
	border-color: #ffba72;
	cursor: not-allowed;
}

.package {
	position: static;
	display: flex;
	align-items: center;
	width: 100%;
	height: 0.34rem;
	margin-top: 0.08rem;
	background: #fff;
	border: 0.0125rem solid #ffd6a8;
	border-radius: 0.1rem;
	box-sizing: border-box;
	color: #ff8200;
}

.package p {
	flex: 1;
	width: auto;
	height: auto;
	line-height: 0.34rem;
	font-size: 0.135rem;
	font-weight: 600;
}

.package i {
	flex: 0 0 0.34rem;
	margin: 0;
	line-height: 0.34rem;
	cursor: pointer;
}

@media (max-width: 767px) {
	.item_welfare {
		width: 10rem;
		background-size: cover;
	}

	.item_welfare .position {
		width: 100%;
		min-height: auto;
		padding: 0.2667rem 0.1333rem 0.6rem;
	}

	.item_welfare ul {
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 0.32rem;
		margin-left: 0;
	}

	.item_welfare ul li.welfare-card {
		min-height: 6.45rem;
		padding: 0.58rem 0.24rem 0.28rem;
		border-radius: 0.32rem;
		box-shadow: 0 0.2rem 0.48rem rgba(32, 39, 55, 0.13);
	}

	.welfare-limit {
		top: 0.16rem;
		right: 0.16rem;
		max-width: 1.85rem;
		padding: 0.05rem 0.16rem;
		border-radius: 0.28rem;
		font-size: 0.28rem;
	}

	.welfare-icon {
		width: 1.72rem;
		height: 1.72rem;
		margin-bottom: 0.34rem;
		border-radius: 0.24rem;
	}

	.first {
		width: 1.25rem;
		height: 1.25rem;
	}

	.welfare_right {
		font-size: 0.32rem;
	}

	.welfare-title {
		min-height: 0.88rem;
		font-size: 0.32rem;
	}

	.prop {
		height: 0.86rem;
		margin-top: 0.12rem;
		font-size: 0.27rem;
	}

	.progress-container {
		height: 0.2rem;
		margin-top: 0.18rem;
	}

	.percentage {
		font-size: 0.17rem;
		line-height: 0.2rem;
	}

	.progress-bar {
		height: 0.2rem;
	}

	.welfare-action {
		padding-top: 0.24rem;
	}

	.receive {
		height: 0.82rem;
		border-radius: 0.22rem;
		font-size: 0.32rem;
	}

	.package {
		height: 0.56rem;
		margin-top: 0.12rem;
		border-radius: 0.16rem;
	}

	.package p {
		line-height: 0.56rem;
		font-size: 0.23rem;
	}

	.package i {
		flex-basis: 0.56rem;
		line-height: 0.56rem;
	}
}
</style>
